export default function ElectricGrill() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_14852)">
                <path
                    d="M43.5 35.25L43.5 11.25C43.5 10.0074 42.4926 9 41.25 9L6.75 9C5.50736 9 4.5 10.0074 4.5 11.25L4.5 35.25C4.5 36.4926 5.50736 37.5 6.74999 37.5L41.25 37.5C42.4926 37.5 43.5 36.4926 43.5 35.25Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M39 22.5L39 15C39 14.1716 38.3284 13.5 37.5 13.5L10.5 13.5C9.67157 13.5 9 14.1716 9 15L9 22.5C9 23.3284 9.67157 24 10.5 24L37.5 24C38.3284 24 39 23.3284 39 22.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="24" cy="33" r="1.5" fill="#949494" />
                <path
                    d="M31.5 33C31.5 33.4142 31.1642 33.75 30.75 33.75C30.3358 33.75 30 33.4142 30 33C30 32.5858 30.3358 32.25 30.75 32.25C31.1642 32.25 31.5 32.5858 31.5 33Z"
                    fill="#949494"
                />
                <path
                    d="M37.5 33C37.5 33.4142 37.1642 33.75 36.75 33.75C36.3358 33.75 36 33.4142 36 33C36 32.5858 36.3358 32.25 36.75 32.25C37.1642 32.25 37.5 32.5858 37.5 33Z"
                    fill="#949494"
                />
                <path
                    d="M18.75 33C18.75 33.4142 18.4142 33.75 18 33.75C17.5858 33.75 17.25 33.4142 17.25 33C17.25 32.5858 17.5858 32.25 18 32.25C18.4142 32.25 18.75 32.5858 18.75 33Z"
                    fill="#949494"
                />
                <path
                    d="M12 33C12 33.4142 11.6642 33.75 11.25 33.75C10.8358 33.75 10.5 33.4142 10.5 33C10.5 32.5858 10.8358 32.25 11.25 32.25C11.6642 32.25 12 32.5858 12 33Z"
                    fill="#949494"
                />
                <path d="M15 16.5V21" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M24 16.5V21" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M33 16.5V21" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M28.5 16.5V21" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M19.5 16.5V21" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="4.5" y1="28.875" x2="43.5" y2="28.875" stroke="#949494" strokeWidth="2.25" />
            </g>
            <defs>
                <clipPath id="clip0_845_14852">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
